module.exports = __webpack_public_path__ + "media/images/japan/nav_2-0e86caa907f389191a6819664ff9cd1e.svg";